import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./BottomNavigation.vue?vue&type=style&index=0&id=e4cb7248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4cb7248"]])

export default __exports__